import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import { FormattedMessage } from "react-intl";

class Faq extends Component {
  render() {
    return (
      <section className="terms">
        <Row>
          <Col xs="12">
            <div className="terms-title-wrap">
              <h2 className="terms-section-title">
                <FormattedMessage id="sidebar.faq" defaultMessage="Faq" />
              </h2>
            </div>
          </Col>
        </Row>
        <Container fluid>
          <Row className="no-gutters">
            <Col xs="12" className="terms-list">
              <h6 className="terms-title">ΠΛΗΡΟΦΟΡΙΕΣ ΓΙΑ ΤΗΝ ΣΥΝΔΡΟΜΗ ΣΑΣ </h6>
              <p className="terms-para">
                Η GAMELORDS παρέχει ψυχαγωγικές υπηρεσίες που συνίστανται στην
                λήψη περιεχομένου για κινητά τηλέφωνα, όπως ήχoι ειδοποίησης,
                φωτογραφίες, παιχνίδια, ειδησεογραφικό υλικό, αστρολογικές
                προβλέψεις και άλλα αντικείμενα.
              </p>
              <p className="terms-para">
                Αφού πραγματοποιήσετε έγκυρη εγγραφή και πληρωμή, μπορείτε να
                λάβετε ορισμένα αρχεία σε συμβατά κινητά τηλέφωνα και συμβατές
                συσκευές μέσω της <strong>GAMELORDS</strong>.
              </p>
              <p className="terms-para">
                Τα μέλη της <strong>GAMELORDS</strong> λαμβάνουν τον προσωπικό
                τους σύνδεσμο κάθε μήνα, με τον οποίο μπορούν να κάνουν λήψη
                διαφορετικού περιεχομένου κάθε φορά.
              </p>
              <p className="terms-para">
                Η Υπηρεσία <strong>GAMELORDS</strong> παρέχεται με μηνιαία
                συνδρομή και συγκεκριμένα θα λαμβάνετε δώδεκα (12) κατά την λήψη
                χρεώσιμα μηνύματα, αξίας 2,29€ έκαστο, ή έως (48) σαράντα οχτώ
                κατά την λήψη χρεώσιμα μηνύματα 0,57€ εκαστο μηνιαίως, συνολική
                χρέωση: 27,48€ ανά μήνα (συμπεριλαμβάνομένων ΦΠΑ και τελών
                κινητής). Τελική Τιμή Μηνύματος
              </p>
              <p className="terms-para">
                Η μηνιαία χρέωση σας θα τιμολογείται αυτόματα μέσω του
                λογαριασμού κινητής τηλεφωνίας του Παρόχου σας
              </p>
              <p className="terms-para">
                Απαραίτητη προϋπόθεση χρήσης της Υπηρεσίας{" "}
                <strong>GAMELORDS</strong> είναι να είστε άνω των 18 ετών, καθώς
                και να σας έχει δοθεί η άδεια του ατόμου που πληρώνει τον
                λογαριασμό κινητής τηλεφωνίας.
              </p>
              <p className="terms-para">
                Η Υπηρεσία <strong>GAMELORDS</strong>, στην Ελλάδα υποστηρίζεται
                από την εταιρεία Sam Media BV., με έδρα την Oλλανδία (Van
                Diemenstraat 356 1013 CR Amsterdam )μέσω των 5ψηφίων κωδικών της
                και της τεχνικής υποδομής της.
              </p>
              <p className="terms-para">
                Για οποιοδήποτε θέμα μπορείτε να επικοινωνήσετε με το Τμήμα
                Εξυπηρέτησης Πελατών τηλεφωνικά στον αριθμό 2112348373 (απλή
                χρέωση από οποιοδήποτε σταθερό τηλέφωνο). Μπορείτε επίσης να
                επικοινωνήσετε και μέσω email στο: sam-media.gr@cchelp.co
              </p>
              <p className="terms-para">
                Εάν επιθυμείτε να διακόψετε τη συνδρομή σας από αυτήν την
                υπηρεσία, στείλτε μήνυμα από το κινητό σας με την λέξη{" "}
                <strong>STOP GL</strong>
                στον κωδικό πενταψήφιο αριθμό <strong>54066/54070</strong> όπου
                είχατε εγγραφεί
              </p>
              <p>
                Το μήνυμα διαγραφής που αποστέλλει ο συνδρομητής στον πενταψήφιο
                κωδικό <strong>54066</strong> έχει κόστος απλού τυπικού
                μηνύματος, που διαφοροποιείται ανά πάροχο κινητής τηλεφωνίας. Η
                επιβεβαίωση διαγραφής αποστέλλεται στον συνδρομητή δωρεάν από
                τον κωδικό <strong>54066</strong>
              </p>
            </Col>
          </Row>
        </Container>
      </section>
    );
  }
}

export default Faq;



// WEBPACK FOOTER //
// ./src/components/Faq/Faq.js